import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {GameColor} from '../../GameColor'
import {TextView} from '../../ui_canvas_engine/TextView'
import {GameFont} from '../../GameFont'
import {turnSecondsInToTimerFormat} from '../../ui_utils/ClientUtils'
import {TranslationObject} from '@colonist/i18n'
import {EndGameState} from '@colonist/game-states'

export class GameEndTimeAndTurnsView extends SectionBgView {
    timeAndTurnsTextView: TextView
    constructor(x: number, y: number, w: number, h: number, container: SectionBgView, endGameState: EndGameState) {
        super(x, y, w, h, container)

        const gameDuration = endGameState.gameDurationInMS
        const text: TranslationObject = {key: 'strings:game.endGame.generalStats', options: {
            timeString: turnSecondsInToTimerFormat(gameDuration / 1000),
            turnCount: String(endGameState.totalTurnCount),
        }}

        this.timeAndTurnsTextView = new TextView(text, 0, 0, this.width, this.height, this,
            GameFont.Size.L, GameColor.getColor(GameColor.Color.Gray3))
        this.timeAndTurnsTextView.centerX()
    }
}
